export default __webpack_public_path__ + "static/media/prof.492b2f0b.svg";